import "./index.scss";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/COMDEX_Logo.png";
import { useState } from "react";
import { truncateString } from '../../utils/strings'
import { fetchKeplrAccountName, initializeChain } from "../../services/keplr";
import Copy from "../../components/copy";
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css'
import { useDispatch } from "react-redux";

const Header = () => {
  const dispatch = useDispatch();
  const [accountName, setAccountName] = useState()
  const [userAddress, setUserAddress] = useState();

  window.addEventListener("keplr_keystorechange", () => {
    handleConnectToKeplr();
  });

  const handleConnectToKeplr = () => {

    initializeChain((error, account) => {
      if (error) {
        window.alert(error);
        return;
      }

      const accountStore = fetchKeplrAccountName();
      setTimeout(() => {
        let accName = localStorage.setItem("accname", accountStore?.name)
        setAccountName(accName);
      }, 500);

      localStorage.setItem("ac", account.address);
      let alreadyConnected = localStorage.getItem("ac");
      dispatch({ type: "USER_ADDRESS", value: alreadyConnected });
      setUserAddress(alreadyConnected)

    });
  };
  function disconnect() {
    localStorage.removeItem('ac');
    localStorage.removeItem('accname');
    dispatch({ type: "USER_ADDRESS", value: "" });
    setUserAddress()
  }
  const menu = (
    userAddress ?
      <div className="disconnect-modal-main-container">
        <div className="disconnect-modal-container">
          <div className="name"><span className="active-status"> </span> {accountName} </div>
          <div className="address">{truncateString(userAddress, 6, 8)} <Copy text={userAddress} />  </div>
          <div className="btn" onClick={() => {
            disconnect();
          }} >Disconnect</div>
        </div>
      </div> :
      <div className="disconnect-modal-main-container">
        <div className="disconnect-modal-container">
          <div className="name">Connect Wallet </div>
          <div className="btn" onClick={() => {
            handleConnectToKeplr();
          }} >Keplr </div>
        </div>
      </div>
  );

  useEffect(() => {
    let alreadyConnected = localStorage.getItem("ac");
    let accName = localStorage.getItem("accname")
    setAccountName(accName);
    setUserAddress(alreadyConnected);
  }, [userAddress, accountName])

  return (
    <section>
      <div className="header-main-bg ">
        <div className="container">
          <div className="header-container">
            <div className="header-left">
              <Link to="/">
                <img src={logo} alt="logo" />
              </Link>
            </div>
            <div className="header-right">
              <div className="header-links-container">
                <div className="links pre-links ">
                  <a href="https://comdex.one/newsroom" target="_blank" aria-label="Newsroom" rel="noreferrer">
                    Newsroom
                  </a>
                </div>
                <div className="links pre-links ">
                  <a href="https://blog.comdex.one/" target="_blank" aria-label="Medium" rel="noreferrer">
                    Blog
                  </a>
                </div>
                <a href="https://dev-cassets.comdex.one/" target="_blank" aria-label="Webapp" rel="noreferrer"> <div className="links btn-primary">
                  <a href="https://dev-cassets.comdex.one/" target="_blank" aria-label="Webapp" rel="noreferrer">
                    WebApp
                  </a>{" "}
                </div></a>
                <a href="https://comdex.one/" target="_blank" aria-label="Website" rel="noreferrer">
                  <div className="links btn-primary">
                    <a href="https://comdex.one/" target="_blank" aria-label="Website" rel="noreferrer">
                      Website
                    </a>{" "}
                  </div></a>
                <Dropdown overlay={menu} trigger={['click']} className="links btn-primary wallet-dropdown">
                  <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                    {userAddress ? "Connected" : "Connect"} <DownOutlined />
                  </a>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
